import { Button, ButtonProps } from '@atoms/index';
import { Phone } from '@phosphor-icons/react';
import { CaretLeft } from '@phosphor-icons/react';
import {
  DefaultCallUsContentBody,
  DefaultCallUsBottomLink,
} from '@molecules/index';
import { useNavigate } from 'react-router-dom';
import { CallUsBanner } from './CallUsBanner';
interface CallUsTemplateProps {
  title?: string;
  subText?: string;
  contentBody?: string | React.ReactNode;
  bottomLink?: string | React.ReactNode;
  callButton?: ButtonProps;
  buttonPrevious?: ButtonProps;
  buttonNext?: ButtonProps;
}

export const CallUsTemplate = ({
  title,
  subText,
  contentBody,
  callButton,
  bottomLink,
  buttonPrevious,
  buttonNext,
}: CallUsTemplateProps) => {
  const navigate = useNavigate();

  const callUsButton = callButton || {
    href: 'tel:+441135182215',
    label: 'Call us',
  };

  const nextButton = buttonNext || {
    label: 'Back to homepage',
    onClick: () => {
      window.location.href = 'https://www.westminster.gov.uk/report-it';
    },
  };

  const previousButton = buttonPrevious || {
    onClick: () => {
      navigate(-1);
    },
  };

  return (
    <div className="flex flex-col gap-6">
      <CallUsBanner title={title} subtext={subText} />
      <div data-testid="call-us-content">
        {contentBody ? contentBody : <DefaultCallUsContentBody />}
      </div>
      {callUsButton ? (
        <div data-testid="call-button" className="mobile:flex hidden">
          <Button
            id="call-button"
            iconRight={<Phone aria-label="Phone icon" />}
            isExternalLink={true}
            href={callUsButton.href}
            {...callUsButton}
          />
        </div>
      ) : null}
      {bottomLink ? bottomLink : <DefaultCallUsBottomLink />}

      <div className="flex w-full flex-wrap items-center justify-between gap-4 py-5 font-bold">
        <section data-testid="button-previous">
          <Button
            id="previous-button"
            variant="secondary"
            color="navigation-secondary"
            iconLeft={<CaretLeft aria-label="chevron right icon" />}
            label={'Previous'}
            onClick={previousButton.onClick}
            {...previousButton}
          />
        </section>

        <section data-testid="navigate-to-homepage">
          <Button
            id="navigation-button"
            variant="primary"
            color="navigation-primary"
            label={nextButton.label}
            onClick={nextButton.onClick}
            {...nextButton}
          />
        </section>
      </div>
    </div>
  );
};
